import { useEffect, useRef, useState } from "react";

export default function useScrollToRef<T extends HTMLElement>() {
    const ref = useRef<T>(null);

    const [scrollPending, setScrollPending] = useState<boolean>(false);

    const scrollToElement = () => {
        setScrollPending(true);
    };

    useEffect(() => {
        if (!scrollPending) return;

        // Defer scrolling until React has painted the DOM and new elements are visible
        requestAnimationFrame(() => {
            ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            setScrollPending(false);
        });
    }, [scrollPending]);

    return {
        ref,
        scrollToElement,
    };
}
